import { Link } from "react-router-dom";

export const SlashMark = ({ size = 28, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
    <polygon points="86,10 94,18 24,92 10,92 10,80" fill={color} />
  </svg>
);

export const Logo = ({ to = "/", light = false, className = "", showWord = true }) => (
  <Link to={to} className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="logo-link">
    <span className="grid place-items-center h-8 w-8 rounded-lg bg-primary overflow-hidden shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5">
      <SlashMark size={20} color="#fff" />
    </span>
    {showWord && (
      <span className={`font-display font-semibold text-lg tracking-[0.18em] uppercase ${light ? "text-white" : "text-foreground"}`}>
        Timeline
      </span>
    )}
  </Link>
);
